import { createRouter, createWebHistory } from 'vue-router'
import ClientPage from '@/views/ClientPage.vue'
import AdminPage from '@/views/AdminPage.vue'
import LoginPage from '@/views/LoginPage.vue'
import { isAuthenticated } from '@/utils/auth'

const routes = [
  // Страница входа
  {
    path: '/login',
    component: LoginPage,
    meta: { requiresGuest: true }
  },

  // Админ-панель (требует авторизации)
  {
    path: '/admin',
    component: AdminPage,
    meta: { requiresAuth: true }
  },

  // Клиентская страница (любой другой путь)
  {
    path: '/:pathMatch(.*)*',
    component: ClientPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guards
router.beforeEach((to, from, next) => {
  const authenticated = isAuthenticated()

  // Если требуется авторизация, но пользователь не авторизован
  if (to.meta.requiresAuth && !authenticated) {
    next('/login')
    return
  }

  // Если гость пытается зайти на страницу для гостей, но уже авторизован
  if (to.meta.requiresGuest && authenticated) {
    next('/admin')
    return
  }

  next()
})

export default router
